module.exports = __webpack_public_path__ + "36112bebea7ce9b92cc26e218d8cad9a.svg";